import { ListTransactionIcon } from '../../../../utils/svg';
import { useSelector } from 'react-redux';
import useNavigation from '../../../../hook/useNavigation';
import { isEmptyData } from '../../../../utils/helper';

const Transaction = () => {
	const navigate = useNavigation();
	const user = useSelector((store) => store?.user);

	const handleOnClick = () => {
		const isLogin = !isEmptyData(user?.token);
		if (!isLogin) return navigate.push('/ufood-x/login')

		return navigate.push('/ufood-x/history')
	}
	return (
		<div className='absolute top-4 right-4 z-5' onClick={() => handleOnClick()}>
			<ListTransactionIcon className={'h-8 w-auto text-white'} opacity={'1'} />
		</div>
	);
};

export default Transaction;
